import FilterParamsUtil from "../../sections/collection-grid/filter-params-util";

const CollectionFilterSpCategories = (el, sectionParams, onClose) => {
  let filterParams = [];
  const categoryList = sectionParams.category_list;
  let otherRowChecked = false;

  const initialize = () => {
    renderCategoryItems();
    el.querySelector(".fs-back-button").addEventListener("click", () => {
      el.classList.remove("show");
      onClose(false, null);
    });
    el.querySelector(".fs-close-button").addEventListener("click", () => {
      el.classList.remove("show");
      onClose(true, null);
    });
    el.querySelector(".fs-clear-button").addEventListener("click", () => {
      const newFilterParams = filterParams.filter((kv) => kv.key != "collections");
      handleChangeFilterParams(newFilterParams);
    });
    el.querySelector(".fs-select-button").addEventListener("click", () => {
      el.classList.remove("show");
      onClose(false, filterParams);
    });
    el.querySelectorAll("input").forEach((input) => {
      input.addEventListener("change", (e) => {
        if (e.target.value == "all") {
          if (e.target.checked) {
            const newFilterParams = filterParams.filter((kv) => kv.key != "product_type");
            handleChangeFilterParams(newFilterParams);
          }
          return;
        }
        if (e.target.checked) {
          const newFilterParams = filterParams.filter((kv) => kv.key != "product_type" || kv.value != "all");
          handleChangeFilterParams([...newFilterParams, { key: e.target.name, value: e.target.value }]);
          return;
        }
        const newFilterParams = filterParams.filter((kv) => kv.key != e.target.name || kv.value != e.target.value);
        handleChangeFilterParams(newFilterParams);
      });
    });
  };

  const show = (newFilterParams) => {
    filterParams = FilterParamsUtil.duplicate(newFilterParams);
    handleChangeFilterParams(newFilterParams);
    renderCategoryItems();
    el.classList.add("show");
  };

  const handleChangeFilterParams = (newFilterParams) => {
    if (filterParams == newFilterParams) {
      return;
    }
    const currentValues = filterParams.filter((fp) => fp.key == "collections").map((fp) => fp.value);
    const newValues = newFilterParams.filter((fp) => fp.key == "collections").map((fp) => fp.value);
    let needsRender = true;
    if (0 < newValues.length) {
      needsRender = newValues.find((nv) => {
        if (currentValues.includes(nv)) {
          return false;
        }
        const category = categoryList.find((c) => c.handle == nv);
        if (!category) {
          return false;
        }
        if (category.levels == 1) {
          return true;
        }
        return false;
      });
    }

    filterParams = newFilterParams;
    if (needsRender) {
      renderCategoryItems();
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const renderCategoryItems = () => {
    const rowsEl = el.querySelector(".fs-item-rows");
    if (!rowsEl.classList.contains("collapse")) {
      rowsEl.classList.add("collapse");
      setTimeout(() => renderCategoryItems(), 400);
      return;
    }
    setTimeout(() => rowsEl.classList.remove("collapse"), 200);
    rowsEl.innerHTML = "";

    const selectedParents = categoryList.filter((categoryItem) =>
      filterParams.find(
        (kv) =>
          kv.key == "collections" &&
          (kv.value == categoryItem.handle || 0 <= categoryItem.items.findIndex((ci) => kv.value == ci.handle)),
      ),
    );
    if (selectedParents.length == 1) {
      addCategoryItemRow(selectedParents[0], true, true, rowsEl);
      addOtherRow(rowsEl, selectedParents[0]);
    } else {
      categoryList.forEach((categoryItem) => {
        addCategoryItemRow(categoryItem, true, false, rowsEl);
      });
    }

    el.querySelectorAll("input").forEach((input) => {
      input.addEventListener("change", (e) => {
        if (e.target.value == "other") {
          otherRowChecked = e.target.checked;
          if (otherRowChecked) {
            rowsEl.querySelector(".fs-other-rows").classList.add("open");
          } else {
            rowsEl.querySelector(".fs-other-rows").classList.remove("open");
          }
          return;
        }
        if (e.target.checked) {
          if (e.target.dataset.levels == 1) {
            const newFilterParams = filterParams.filter((kv) => kv.key != "collections");
            otherRowChecked = false;
            handleChangeFilterParams([...newFilterParams, { key: e.target.name, value: e.target.value }]);
            return;
          }
          const selectedParent = categoryList.find(
            (categoryItem) =>
              categoryItem.levels == 1 && 0 <= categoryItem.items.findIndex((ci) => ci.handle == e.target.value),
          );
          const removeItemHandles = selectedParent.items.map((categoryItem) => categoryItem.handle);
          const newFilterParams = filterParams.filter(
            (kv) =>
              kv.key != "collections" ||
              (kv.key == "collections" && selectedParent.handle != kv.value && !removeItemHandles.includes(kv.value)),
          );
          rowsEl.querySelectorAll(`input[data-levels="1"]`).forEach((input) => {
            input.checked = false;
          });
          rowsEl.querySelectorAll(`input[data-levels="0"]`).forEach((input) => {
            if (input.value != e.target.value) {
              input.checked = false;
            }
          });
          handleChangeFilterParams([...newFilterParams, { key: e.target.name, value: e.target.value }]);
        } else {
          if (e.target.dataset.levels == 1) {
            const newFilterParams = filterParams.filter((kv) => kv.key != "collections");
            otherRowChecked = false;
            handleChangeFilterParams(newFilterParams);
            return;
          }
          const newFilterParams = filterParams.filter(
            (kv) => kv.key != "collections" || (kv.key == "collections" && kv.value != e.target.value),
          );
          handleChangeFilterParams(newFilterParams);
        }
      });
    });
  };

  const addCategoryItemRow = (categoryItem, isParent, isOpen, itemRowsEl) => {
    const identifier = `fs_collections_sp_${categoryItem.identifier}`;
    const className = isParent ? "fs-parent" : "fs-child";
    const checked = 0 <= filterParams.findIndex((kv) => kv.key == "collections" && kv.value == categoryItem.handle);
    const itemRow = `
      <div class="fs-item-row">
        <label for="${identifier}" class="${className}">
          ${categoryItem.title}
        </label>
        <div class="checkmark">
          <input
            id="${identifier}"
            type="checkbox"
            class="${className}"
            name="collections"
            value="${categoryItem.handle}"
            data-levels="${categoryItem.levels}"
            ${checked ? "checked" : ""}
          >
        </div>
      </div>
    `;
    itemRowsEl.innerHTML += itemRow;
    if (isOpen) {
      categoryItem.items?.forEach((childCategoryItem) =>
        addCategoryItemRow(childCategoryItem, false, false, itemRowsEl),
      );
    }
  };

  const addOtherRow = (itemRowsEl, selectedParent) => {
    const identifier = "fs_collections_sp_other";
    const className = "fs-parent";
    const itemRow = `
      <div class="fs-item-row">
        <label for="${identifier}" class="${className}">
          その他のカテゴリー
        </label>
        <div class="checkmark arrow">
          <input
            id="${identifier}"
            type="checkbox"
            class="${className}"
            name="collections"
            value="other"
            data-levels="1"
            ${otherRowChecked ? "checked" : ""}
          >
        </div>
      </div>
    `;
    itemRowsEl.innerHTML += itemRow;

    const otherRows = document.createElement("div");
    otherRows.classList.add("fs-other-rows");
    if (otherRowChecked) {
      otherRows.classList.add("open");
    }
    categoryList.forEach((categoryItem) => {
      if (categoryItem.identifier != selectedParent.identifier) {
        addCategoryItemRow(categoryItem, false, false, otherRows);
      }
    });
    itemRowsEl.innerHTML += otherRows.outerHTML;
  };

  initialize();
  return {
    show: show,
  };
};

export default CollectionFilterSpCategories;
